import { render, staticRenderFns } from "./dailzf.vue?vue&type=template&id=51b4248e&scoped=true&"
import script from "./dailzf.vue?vue&type=script&lang=js&"
export * from "./dailzf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4248e",
  null
  
)

export default component.exports